export class TaggedPhoto {

  public name : String;
  public photoTag : number;
  public workday : number;
  public photoIds : number[] = new Array();

  public static fromJson(json: Object): TaggedPhoto {
    const o: TaggedPhoto = new TaggedPhoto();

    o.photoTag = json['photoTag'];
    o.workday = json['workDay'];
    o.photoIds = json['photoIds'];
    if(o.photoIds)
      console.log("from phooto =" + o.photoIds.length)

    return o;
  }
}



// WEBPACK FOOTER //
// ./src/model/TaggedPhoto.ts